/** Persona avatar background token map — web and mobile read the same source. */
import type { PersonaId } from "@petci/domain";

/**
 * Maps each PersonaId to its NativeWind / Tailwind background class.
 * Token names use the brand-* prefix per packages/branding/src/tokens.ts.
 */
export const PERSONA_AVATAR_TOKENS: Record<PersonaId, string> = {
  P1: "bg-brand-primary",
  P2: "bg-brand-secondary",
  P3: "bg-brand-secondary-mid",
  P4: "bg-neutral-700",
  P5: "bg-neutral-300", // hidden in Phase 1; defensive default
};
